// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"9de9f773","412":"25d625cc","899":"f1055320","996":"f1055320"}[chunkId] + ".chunk.css";
};